// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__196bY","savePackageButton":"ClientWallet_savePackageButton__2yHBB"};